// MA-874 (operator D-1101-23) — the kid-register skill labels, as a pure leaf.
//
// Moved verbatim out of journeyView.ts (which imports the curriculum manifest
// and the engine) so a server bundle (the weekly recap's
// api/_lib/recapDetail.bundle.mjs) can read the labels Progress passes without
// pulling the curriculum data. journeyView re-exports it unchanged.
// Keep this module import-free.

// ── D3 — kid-register labels for ALL 54 rendered ids (D4-clean,
// descriptive, no age/grade words). NO fallback for a rendered id — an
// unmapped rendered id FAILS the build (see kidLabelFor below), not a
// silent jargon leak. The first 10 entries are the unchanged v1 milestone
// map; the remaining 44 are the D3 support-skill table (Fable-authored). ──
export const KID_LABEL_MAP: Record<string, string> = {
  // ── v1 milestone map (unchanged) ──
  "ms.read.01": "Letter names",
  "ms.read.02": "Letter sounds",
  "ms.math.00b": "Counting to 10",
  "ms.math.01": "How many at a glance",
  "ms.read.06": "Sounding out words",
  "ms.math.09": "Adding to 10",
  "ms.read.13": "Finishing little stories",
  "ms.math.11": "Adding & taking away to 20",
  "ms.math.18": "Times tables to 5×5",
  "ms.read.19": "Reading detective work",
  // ── D3 support-skill table (44 entries) ──
  "ms.read.03": "Writing letters",
  "ms.read.04": "Sounds to letters",
  "ms.math.02": "Counting things",
  "ms.math.04": "Spotting numbers",
  "ms.read.0a": "Rhyming words",
  "ms.read.0b": "Clapping word beats",
  "ms.math.00d": "Numbers 0 to 10",
  "ms.math.00g": "Patterns",
  "ms.math.05": "Making 5",
  "ms.read.07": "Building little words",
  "ms.read.dolch_trace": "Tracing star words",
  "ms.math.07": "Adding to 5",
  "ms.math.08": "Taking away to 5",
  "ms.read.08": "Star words",
  "ms.read.17": "Kinds of words",
  "ms.read.10": "Finishing sentences",
  "ms.math.06": "Making 10",
  "ms.math.10": "Taking away to 10",
  "ms.read.16": "Big new words",
  "ms.math.13": "Teen numbers",
  "ms.read.09": "Bigger word sounds",
  "ms.math.12": "Missing numbers",
  "ms.read.15": "Sneaky quiet letters",
  "ms.math.03": "More or fewer",
  "ms.read.11": "Letter teams",
  "ms.read.12": "Magic e words",
  "ms.read.18": "Understanding stories",
  "ms.math.20": "Tens and ones",
  "ms.math.21": "Building big numbers",
  "ms.read.21": "Word beginnings & endings",
  "ms.math.15": "Number stories",
  "ms.read.14": "Double letters",
  "ms.math.16": "Counting by hops",
  "ms.math.17": "Equal groups",
  "ms.math.19": "Fair sharing",
  "ms.math.14": "Adding bigger numbers",
  "ms.read.20": "Story order",
  "ms.read.22": "Root words",
  "ms.math.22": "Halves and quarters",
  "ms.math.23": "Biggest share",
  "ms.math.24": "Counting coins",
  "ms.math.25": "Telling time",
  "ms.math.26": "Really big adding",
  "ms.math.27": "Times tables to 10",
  "ms.math.28": "Matching fractions",
  "ms.math.29": "Odd and even",
};
